import React, { Suspense } from 'react'
// import PageLoading from '~/layout/PageContainer/PageLoading'

const lazyLoad = (Component) => {
  return (
    <Suspense>
      <Component />
    </Suspense>
  )
}

export default lazyLoad
